<template>
	<div class="customFixed-vue alertPOP darkFadeBG loginInfo">
	    <div class="custom-modal showTabs secondary-color openHeader">
	    	<div class="mainContent" v-if="!resend">
	    		<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0">{{$t('forgot_password') }} </p>
					<!-- <span class="closePOP" @click.prevent="$parent.page_type = ''"><feather size="13px" type="x"></feather></span> -->
	    		</div>
	    		<div class="mainTab-one pb-3">
			    	<form class="updateWrap" @submit.prevent="resetPass()">
			    		<div class="form-fields d-flex align-items-center mb-3">
			    			<input type="text" placeholder="Enter Username" name="Username" v-model="Username" v-validate="'required|max:30'" ref="UsernameInput" maxlength="30">
			    			<span class="text-danger" v-if="submitted && errors.has('Username')">{{ errors.first('Username') }}</span>
			    		</div>
			    		
			    		<div class="form-fields d-flex align-items-center mb-3">
							<select class="selectBox" v-model="server" name="Server Type" v-validate="'required'" :ref="'Server TypeInput'">
								<option value="" disabled>{{$t('server_type') }} </option>
								<option :value="key" v-for="list,key in providerList">{{list}}</option>
							</select>
							<span class="text-danger" v-if="submitted && errors.has('Server Type')">{{ errors.first('Server Type') }}</span>
						</div>
			    		
						<div class="fullWidh d-flex align-items-center justify-content-between text-center px-2 my-4">
							<a href="#" @click.prevent="$parent.page_type = 'login'">{{$t('back_to_login') }} </a>
							<button class="btn appButton linkBG justify-content-center">{{$t('submit') }} </button>
						</div>
					</form>
			    </div>
	    	</div>
	    	<div class="mainContent" v-else>
	    		<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0">{{$t('check_email') }}</p>
					<!-- <span class="closePOP" @click.prevent="$parent.page_type = ''"><feather size="13px" type="x"></feather></span> -->
	    		</div>
	    		<div class="mainTab-one pb-3">
					<div class="congratulationMsg">
			    		<div class="upImage text-center">
			    			<span class="proIcon"><feather size="20px" type="mail"></feather></span>	
			    			<p class="f-12 my-3">{{$t('reset_password_msg') }}  <a href="#" @click.prevent="resetPass()">{{$t('resend') }} </a></p>
			    			<div class="d-flex align-items-center justify-content-center px-2">
			    				<a class="btn appButton linkBG justify-content-center" href="#" @click.prevent="$parent.page_type = 'login'">{{$t('back_to_login') }} </a>
			    			</div>
			    		</div>
						
					</div>
			    </div>
	    	</div>
	    </div>
    </div>
</template>
<script>
import { commonAllmixins } from '@/plugins/commonAll'
import * as types from '@/types'
export default {
    name: 'app-forget-password',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader : false,
            otp: '',
            // change-password
            resend: false,
            Username: '',
            server: '',
            submitted: false,
        }
    },
    methods:{
    	resetPass(){
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'email' : _that.Username,
                            // 'password' : _that.password,
                            'server_type' : _that.server,
                        },
                        'localParams' :{ "parameter" : _that }
                    }
                    _that.$store.dispatch(types.RUN_FORGOT_PASSWORD,input_json)
                }/*else{
                    _that.handleValidationErrorAdvanced(_that.errors)
                }*/
            });
        },
    },
    created(){
    	// this._runGetProviderList({ 'globalParams' : {},'localParams' : { 'parameter' : this } })
    },
    mounted() {
		const _that = this
        $(document).on("click", function(event){
			if(!$(event.target).closest('.openHeader').length){
                _that.openHeader = false
            }
        });
	}
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/user/reset-password.vue